import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { assetUrl } from '../assets.js';

/**
 * Promosyon/tanıtım görseli. Konum (tam ekran / şerit / yan panel) ve oran renderer
 * tarafından host'a flex ile verilir; bu component yalnızca host kutusunu doldurur.
 * asset_id UUID → assetUrl() helper ile public API endpoint çözümü.
 * Faz 2: Gateway initial_state.assets map'inden signed URL lookup.
 */
@customElement('fp-promo-image')
export class FpPromoImage extends LitElement {
    @property({ type: String, attribute: 'asset-id' }) assetId = '';
    @property({ type: String }) fit: 'contain' | 'cover' | 'fill' = 'cover';

    createRenderRoot(): HTMLElement {
        // Light DOM — host'a block + tam doldurma (flex item olarak boyutlanır).
        this.style.display = 'block';
        this.style.overflow = 'hidden';
        this.style.minWidth = '0';
        this.style.minHeight = '0';
        return this;
    }

    render() {
        if (!this.assetId) {
            return html`
                <div class="w-full h-full flex items-center justify-center"
                     style="background: var(--fp-surface, var(--fp-color-surface)); color: var(--fp-color-fg-muted);">
                    <span class="text-lg">Görsel atanmadı</span>
                </div>
            `;
        }
        // Wrapper overflow-hidden + bg → cover/contain her durumda kutuyu temiz doldurur,
        // taşma olmaz; contain'de boşluklar tema arka planıyla dolar.
        return html`
            <div class="w-full h-full overflow-hidden" style="background: var(--fp-color-bg);">
                <img
                    src="${assetUrl(this.assetId)}"
                    alt=""
                    class="block w-full h-full"
                    style="object-fit: ${this.fit};"
                >
            </div>
        `;
    }
}
